'use client';

import { BubbleBadge } from '@yanolja-rnd/nol-design-system';
import { type FC, useEffect, useState } from 'react';

interface BusinessQuickCategoryBadgeProps {
  title?: string;
  texts?: string[];
  rollingInterval?: number;
}

const BusinessQuickCategoryBadge: FC<BusinessQuickCategoryBadgeProps> = ({ title, texts, rollingInterval = 1000 }) => {
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    // texts가 있고 2개 이상일 때만 롤링 애니메이션 실행
    if (!texts || texts.length <= 1) return;

    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % texts.length);
    }, rollingInterval);

    return () => clearInterval(interval);
  }, [texts, rollingInterval]);

  // 표시할 텍스트 결정: texts가 있으면 현재 인덱스의 텍스트, 없으면 title
  const displayText = texts && texts.length > 0 ? texts[currentIndex] : title;

  if (!displayText) return null;

  return (
    <div className="absolute -top-10 pc:-top-18">
      <BubbleBadge>
        <span className="typography-label-8-bold-fixed pc:typography-body-12-bold-fixed">{displayText}</span>
      </BubbleBadge>
    </div>
  );
};

export default BusinessQuickCategoryBadge;
